import { NAME } from './constants';

export const SEND_EMAIL = `${NAME}/SEND_EMAIL`;
export const SEND_EMAIL_SUCCESS = `${NAME}/SEND_EMAIL_SUCCESS`;
export const SEND_EMAIL_FAILURE = `${NAME}/SEND_EMAIL_FAILURE`;
